import { fiscalDate } from '@makila/fiscal';
const MONTHS = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
export const periodLabel = (p) => `${MONTHS[Number(p.slice(5, 7)) - 1]} ${p.slice(0, 4)}`;
const nextPeriod = (p) => { const y = Number(p.slice(0, 4)), m = Number(p.slice(5, 7)); return m === 12 ? `${y + 1}-01` : `${y}-${String(m + 1).padStart(2, '0')}`; };
/**
 * Meses por cobrar: do mês seguinte ao último pago (ou do início do contrato)
 * até ao mês corrente — este só a partir do dia de cobrança. Nunca depois do
 * fim do contrato. No máximo 12 (o resto vê-se na gestão).
 */
export function duePeriods(c, today = fiscalDate(), charged = new Set()) {
    if (!c.active)
        return [];
    const current = today.slice(0, 7);
    const last = Number(today.slice(8, 10)) >= c.billingDay ? current : (() => { const y = Number(current.slice(0, 4)), m = Number(current.slice(5, 7)); return m === 1 ? `${y - 1}-12` : `${y}-${String(m - 1).padStart(2, '0')}`; })();
    const end = c.endsOn ? c.endsOn.slice(0, 7) : null;
    let p = c.paidUntil ? nextPeriod(c.paidUntil) : c.startsOn.slice(0, 7);
    const out = [];
    while (p <= last && (!end || p <= end) && out.length < 12) {
        if (!charged.has(`${c.id}|${p}`))
            out.push(p);
        p = nextPeriod(p);
    }
    return out;
}
/** A manutenção está vencida? */
export const maintenanceOverdue = (c, today = fiscalDate()) => !!c.maintenanceDue && c.maintenanceDue < today;
/** Linha da mensalidade de um mês (o serviço de aluguer do catálogo dá a taxa de IVA). */
export function rentalLine(c, period, service) {
    return {
        productId: c.productId, description: `${service.name} — ${c.equipment}${c.serial ? ` n.º ${c.serial}` : ''} (${periodLabel(period)})`,
        quantity: '1', unitPrice: c.monthlyFee, taxRate: service.taxRate, priceIncludesTax: service.priceIncludesTax, exemptionCode: service.exemptionCode ?? null,
        contractId: c.id, period,
    };
}
/** Meses já cobrados nesta caixa e ainda por enviar (não se cobram duas vezes antes de o catálogo voltar). */
export function pendingCharges(events) {
    const out = new Set();
    for (const e of events) {
        if (e.type !== 'document.issued')
            continue;
        const d = e.payload;
        if (!['VD', 'FR', 'FT'].includes(d.docType))
            continue;
        for (const l of d.lines)
            if (l.contractId && l.period)
                out.add(`${l.contractId}|${l.period}`);
    }
    return out;
}
//# sourceMappingURL=contracts.js.map